import cls from "./BlogCallout.module.css";
import { InfoCircleIcon } from "@/utils/images/Blog";

interface BlogCalloutProps {
    title: string;
    text: string;
}

export const BlogCallout = ({ title, text }: BlogCalloutProps) => {
    return (
        <div className={cls.callout}>
            <p className={cls.title}>
                <span className={cls.icon}><InfoCircleIcon /></span>
                {title}
            </p>
            <p className={cls.text}>{text}</p>
        </div>
    );
};
